// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 Copyright 2024 European Commission

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

:root{
    --sw-toolbar-btn-background-color: #18191a;
    --sw-anchor-active-primary-color: #18191a;
    --sw-anchor-active-secondary-color: #ffffff;
    --sw-anchor-done-primary-color: #595d61;
    --sw-progress-color: #18191a;
    --sw-progress-background-color: #f8f9fa;
    --sw-loader-color: #18191a;
}
main{
  padding:1em;
}

nav ul li .nav-link{
  color: white !important;
  font-weight: 200;
}

nav ul li .nav-link.active{
  font-weight: 500 !important;
}

body{
    background-color: whitesmoke !important;
    padding-top:5em;
}

a{
    text-decoration: none;
}

a:hover{
    text-decoration: underline;
}

.certificateContainer{
    padding:1em 2em;
    max-height: 500px;
    overflow: auto;
    text-align: center;
}

footer {
    background-color: black;
    color: #fff;
    padding: 20px 0;
  }
  
  .footer-column {
    text-align: center;
    display: flex;
    flex-direction: column;
  }
  

  .footer-column a {
    color: #fff;
    text-decoration: none;
    margin: 5px;
  }

  .footer-column a:hover {
    text-decoration: underline;
  }

  .footer-column img {
    max-width: 100%;
    height: auto;
    margin: 5px;
  }

  .footer-image{
    
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #createCert{
    margin-bottom: 0em;
  }

  @media (max-width: 767.98px) {
    #createCert{
      margin-bottom: 1em;
    }
  }`, "",{"version":3,"sources":["webpack://./src/site.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,2CAA2C;IAC3C,uCAAuC;IACvC,4BAA4B;IAC5B,uCAAuC;IACvC,0BAA0B;AAC9B;AACA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;IACI,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;;;EAGA;IACE,WAAW;IACX,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE;MACE,kBAAkB;IACpB;EACF","sourcesContent":["/*\r\n Copyright 2024 European Commission\r\n\r\n Licensed under the Apache License, Version 2.0 (the \"License\");\r\n you may not use this file except in compliance with the License.\r\n You may obtain a copy of the License at\r\n\r\n      https://www.apache.org/licenses/LICENSE-2.0\r\n\r\n Unless required by applicable law or agreed to in writing, software\r\n distributed under the License is distributed on an \"AS IS\" BASIS,\r\n WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\r\n See the License for the specific language governing permissions and\r\n limitations under the License.\r\n */\r\n\r\n:root{\r\n    --sw-toolbar-btn-background-color: #18191a;\r\n    --sw-anchor-active-primary-color: #18191a;\r\n    --sw-anchor-active-secondary-color: #ffffff;\r\n    --sw-anchor-done-primary-color: #595d61;\r\n    --sw-progress-color: #18191a;\r\n    --sw-progress-background-color: #f8f9fa;\r\n    --sw-loader-color: #18191a;\r\n}\r\nmain{\r\n  padding:1em;\r\n}\r\n\r\nnav ul li .nav-link{\r\n  color: white !important;\r\n  font-weight: 200;\r\n}\r\n\r\nnav ul li .nav-link.active{\r\n  font-weight: 500 !important;\r\n}\r\n\r\nbody{\r\n    background-color: whitesmoke !important;\r\n    padding-top:5em;\r\n}\r\n\r\na{\r\n    text-decoration: none;\r\n}\r\n\r\na:hover{\r\n    text-decoration: underline;\r\n}\r\n\r\n.certificateContainer{\r\n    padding:1em 2em;\r\n    max-height: 500px;\r\n    overflow: auto;\r\n    text-align: center;\r\n}\r\n\r\nfooter {\r\n    background-color: black;\r\n    color: #fff;\r\n    padding: 20px 0;\r\n  }\r\n  \r\n  .footer-column {\r\n    text-align: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  \r\n\r\n  .footer-column a {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    margin: 5px;\r\n  }\r\n\r\n  .footer-column a:hover {\r\n    text-decoration: underline;\r\n  }\r\n\r\n  .footer-column img {\r\n    max-width: 100%;\r\n    height: auto;\r\n    margin: 5px;\r\n  }\r\n\r\n  .footer-image{\r\n    \r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  #createCert{\r\n    margin-bottom: 0em;\r\n  }\r\n\r\n  @media (max-width: 767.98px) {\r\n    #createCert{\r\n      margin-bottom: 1em;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
